import { PERIOD } from "@/enums/period.enum";

const periodPriceMultiplier = (period, price) => {
  let multiplier = 1;

  return (price * multiplier).toFixed(2);
};

export default {
  overLimitUsage: state => currentPlanLimits => {
    const generalLimitsUsage = state.limitsUsage;
    const localCurrentPlanLimits = { ...currentPlanLimits };
    // Remove id and name from currentPlanLimits
    delete localCurrentPlanLimits.id;
    delete localCurrentPlanLimits.name;

    return Object.keys(localCurrentPlanLimits)
      .filter(limit => {
        return generalLimitsUsage[limit] > localCurrentPlanLimits[limit];
      })
      .map(limit => ({
        key: limit,
        maximumLimit: localCurrentPlanLimits[limit],
        currentUsage: generalLimitsUsage[limit]
      }));
  },
  locationsQuantityFromLimitsUsage: state => {
    return state.limitsUsage.max_facilities;
  },
  paymentPlans: state => {
    return state.plans;
  },
  promotionCode: state => {
    if (!state.promotionCodes) return "";
    return (
      state.promotionCodes.find(item => {
        return item.period === (state.selectedPeriod === "month" ? 1 : 2);
      }).code || ""
    );
  },
  getPlanPerPeriod: state => (planId, period) => {
    const selectedPlan = state.plans.find(plan => plan.product_id === planId);
    if (!state.plans.length) {
      return [];
    }
    return selectedPlan.prices.filter(
      price => price.recurring.interval === period
    );
  },
  price: state => {
    const grossPrice = (state.pricePreview / 100).toFixed(2);
    const taxPrice = (state.taxPrice / 100).toFixed(2);
    const netPrice = grossPrice - taxPrice;
    return periodPriceMultiplier(state.selectedPeriod, netPrice);
  },
  taxPrice: state => {
    const taxPrice = (state.taxPrice / 100).toFixed(2);
    return periodPriceMultiplier(state.selectedPeriod, taxPrice);
  },
  taxPercentage: state => {
    const grossAmount = parseFloat((state.pricePreview / 100).toFixed(2));
    const taxAmount = parseFloat((state.taxPrice / 100).toFixed(2));
    const netAmount = parseFloat((grossAmount - taxAmount).toFixed(2));

    if (netAmount === 0) return "0";

    const taxPercentage = ((taxAmount / netAmount) * 100).toFixed(0);
    return taxPercentage;
  },
  getPricePerLocation: () => (getPlanPerPeriod, upTo) => {
    if (!getPlanPerPeriod[0]) {
      return "0";
    }

    const mapTiers = tiers =>
      tiers.map(tier => ({
        upTo: tier.up_to === null ? 20 : tier.up_to,
        unitAmount: +tier.unit_amount_decimal
      }));

    const formatUnitAmount = unitAmount => (unitAmount / 100).toFixed(2);

    const createTier = (from, to, unitAmount) => ({
      from,
      to,
      unitAmount: formatUnitAmount(unitAmount)
    });

    const reduceTiers = price =>
      price.reduce((acc, curr, index) => {
        if (index === 0) {
          acc.push(createTier(1, curr.upTo, curr.unitAmount));
        } else {
          acc.push(
            createTier(acc[index - 1].to + 1, curr.upTo, curr.unitAmount)
          );
        }
        return acc;
      }, []);

    const findRange = (ranges, upTo) =>
      ranges.find(range => upTo >= range.from && upTo <= range.to);

    const price = mapTiers(getPlanPerPeriod[0].tiers);
    const ranges = reduceTiers(price);
    return findRange(ranges, upTo).unitAmount || 0;
  },
  getPriceId(state) {
    if (!state.selectedPlan) {
      return null;
    }
    return state.selectedPlan.prices.find(item => {
      return item.recurring.interval === state.selectedPeriod;
    }).price_id;
  }
};
